<template>
  <div :class="{ active: opened.length > 0 }" class="side-box">
    <span class="side-box__overlay" />
    <div
      v-if="service"
      :class="{
        opened: opened.indexOf('serviceDetail') >= 0,
        'last-active': opened.indexOf('serviceDetail') == opened.length - 1
      }"
      class="side-box__inner"
    >
      <div class="side-box__header d-flex justify-content-between align-items-center">
        <div class="atom-back atom-back--gray" @click="closeBox('serviceDetail')">
          <div class="atom-back__inner d-flex align-items-center">
            <img src="@/assets/icons/arrows/arr-gray-left.svg" />
            <span>{{ $t("zpet") }}</span>
          </div>
        </div>
        <!--button class="btn btn-primary" @click="runEdit()">
          <div class="atom-icon"><img src="@/assets/icons/actions/ico-btn-ulozit.svg"></div>{{ $t("ulozitRoutovaciSkupinu") }}
        </button-->
      </div>
      <div class="side-box__title">
        <h2>{{ $t("detailSluzby") }} {{ service.custServiceName }}</h2>
      </div>
      <div class="side-box__content">
        <div class="my-4">
          <div class="side-box__row d-flex align-items-start mt-3">
            <span class="side-box__content__label side-box__content__label--large text gray-text">
              {{ $t("idSluzby") }}
            </span>
            <span class="side-box__content__value ml-3">{{ service.custServiceId }}</span>
          </div>
          <div class="side-box__row d-flex align-items-start mt-3">
            <span class="side-box__content__label side-box__content__label--large text gray-text">
              {{ $t("tarifName") }}
            </span>
            <span class="side-box__content__value ml-3">{{ service.tarifName }}</span>
          </div>
          <div class="side-box__row d-flex align-items-start mt-3">
            <span class="side-box__content__label side-box__content__label--large text gray-text">
              {{ $t("custState") }}
            </span>
            <span class="side-box__content__value ml-3">{{ service.custState }}</span>
          </div>
        </div>
        <div class="my-4">
          <a
            :class="{ opened: projectsOpened }"
            class="atom-form-group__toggler"
            @click="projectsOpened = projectsOpened ? false : true"
          >
            {{ $t("prehledVsechProjektu") }}
            <img class="atom-form-group__toggler__arrow" src="@/assets/icons/arrows/arr-orange-down.svg" />
          </a>

          <div :class="{ opened: projectsOpened }" class="atom-form-group__content">
            <div
              v-for="project in projects"
              :key="project.projectId"
              class="side-box__row d-flex align-items-start mt-3"
            >
              <span class="side-box__content__label side-box__content__label--large text gray-text">
                {{ project.projectName }}
              </span>
              <span class="side-box__content__value ml-3">{{ project.projectId }}</span>
            </div>
          </div>
        </div>
        <!--div v-if="errors.device" class="text-danger">{{ errors.device }}</div-->
        <div class="my-4">
          <a
            :class="{ opened: countersOpened }"
            class="atom-form-group__toggler"
            @click="countersOpened = countersOpened ? false : true"
          >
            {{ $t("aktualniPoctyZaObdobi") }}
            <img class="atom-form-group__toggler__arrow" src="@/assets/icons/arrows/arr-orange-down.svg" />
          </a>

          <div v-if="counters.length" :class="{ opened: countersOpened }" class="atom-form-group__content">
            <div
              v-for="counter in counters"
              :key="counter.counterId"
              class="side-box__row d-flex align-items-start mt-3"
            >
              <span class="side-box__content__label side-box__content__label--large text gray-text">
                {{ $t(counter.name ?? "") }}
              </span>
              <span class="side-box__content__value ml-3">{{ counter.value }}</span>
            </div>
          </div>
        </div>
        <div class="my-4">
          <a
            :class="{ opened: limitsOpened }"
            class="atom-form-group__toggler"
            @click="limitsOpened = limitsOpened ? false : true"
          >
            {{ $t("limity") }}
            <img class="atom-form-group__toggler__arrow" src="@/assets/icons/arrows/arr-orange-down.svg" />
          </a>

          <div :class="{ opened: limitsOpened }" class="atom-form-group__content">
            <div
              v-for="(paramName, index) in parametersNames"
              :key="index + 'c'"
              class="side-box__row d-flex align-items-start mt-3"
            >
              <span class="side-box__content__label side-box__content__label--large text gray-text">
                {{ $t(getParameter(paramName).name ?? "") }}
              </span>
              <span
                v-if="getParameter(paramName).value == '0' || getParameter(paramName).value == 0"
                class="side-box__content__value ml-3"
              >
                {{ $t("neomezene") }}
              </span>
              <span v-else class="side-box__content__value ml-3">{{ getParameter(paramName).value }}</span>
            </div>

            <div v-if="getParameter('PREREGISTRATION_DAYS') !== ''" class="side-box__row d-flex align-items-start mt-3">
              <span class="side-box__content__label side-box__content__label--large text gray-text">
                {{ $t("COUNTER-PREREGISTRATION_DAYS") }}
              </span>
              <span class="side-box__content__value ml-3">{{ getParameter("PREREGISTRATION_DAYS").value }}</span>
            </div>
            <div v-if="getParameter('PREREGISTRATION_MSGS') != ''" class="side-box__row d-flex align-items-start mt-3">
              <span class="side-box__content__label side-box__content__label--large text gray-text">
                {{ $t("COUNTER-PREREGISTRATION_MSGS") }}
              </span>
              <span class="side-box__content__value ml-3">{{ getParameter("PREREGISTRATION_MSGS").value }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--save-confirmation-modal :opened="openedEndpointConfirmation" :text="'chceteUlozitProvedeneZmeny'" @yes="runSave()" @no="closeBox('serviceDetail')" @close="toggleConfirmation"/-->
    <!--div v-if="errorsToTranslate.length > 0">
      <error-modal :opened="openedError" :centered="true" :errors="errorsToTranslate" @close="openedError = false;"/>
    </div-->
  </div>
</template>

<script>
//import _ from "lodash";
import axios from "axios"
//import SaveConfirmationModal from "@/components/confirmations/save.vue";
//import ErrorModal from "@/components/confirmations/translatedErrors.vue";
export default {
  components: {
    //"save-confirmation-modal": SaveConfirmationModal,
    //"error-modal": ErrorModal
  },
  props: {
    customer: Object,
    service: Object,
    opened: Array
  },
  data() {
    return {
      limitsOpened: true,
      countersOpened: true,
      projectsOpened: true,
      counters: [],
      projects: [],
      parametersNames: [
        "COUNTER-DEV_LMT_ACTUAL",
        "COUNTER-DEV_LMT_PERIODIC",
        "COUNTER-IN_MSG_LMT_SYS",
        "COUNTER-IN_MSG_LMT_USR",
        //"COUNTER-MSG_LMT_USR_PERIOD",
        "COUNTER-OUT_MSG_LMT_SYS",
        "COUNTER-OUT_MSG_LMT_USR"
      ]
      //openedConfirmation: false,
      //errorsToTranslate: [],
      //openedError: false,
    }
  },
  computed: {},
  watch: {},
  mounted() {
    console.log(this.service.custServiceId, "SERVICE ID")
    console.log("PARAMS: ")
    for (let x = 0; x < this.service.parameters.length; x++) {
      console.log(this.service.parameters[x].name)
    }
    //this.loadService();
    this.loadCounters()
    this.loadProjects()
  },
  methods: {
    openBox(box) {
      this.$emit("openBox", box)
    },
    closeBox(box) {
      if (box === "serviceDetail") {
        //this.resetValues();
        this.$emit("closeBox", box)
      } else {
        //this.resetValues();
        this.errors.endpoint = ""
        this.$emit("closeBox", box)
      }
    },
    loadProjects() {
      this.projects = []
      axios
        .get(process.env.VUE_APP_API + "/services/" + this.service.custServiceId + "/projects")
        .then((result) => {
          this.projects = result.data.data
        })
        .catch(() => {})
    },
    loadCounters() {
      this.counters = []
      axios
        .get(process.env.VUE_APP_API + "/services/" + this.service.custServiceId + "/counters?limit=1000")
        .then((result) => {
          this.counters = result.data.data
        })
        .catch(() => {})
    },
    getParameter(name) {
      let param = this.service.parameters.filter((parameter) => parameter.name == name)
      return param.length > 0 ? param[0] : ""
    }
  }
}
</script>

<style lang="scss" scoped></style>
